import React, { useContext, useEffect, useState } from 'react';
import './contact-us.css';
import TextField from '@mui/material/TextField';
import {
  Divider,
  InputBase,
  MenuItem,
  Paper,
  Select,
  Button,
} from '@mui/material';
import 'react-phone-input-2/lib/style.css';
import '../../styles/muiStyles.css';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CallIcon from '@mui/icons-material/Call';
import RSAIcon from '../../assets/icons/contactIcons/rsaContact.png';
import { MyContext } from '../../context';

function ContactUs() {
  const { pageData, country } = useContext(MyContext);
  const [phone, setPhone] = useState(pageData?.contactUsPage?.phoneCode);

  const handleChange = (event) => {
    setPhone(event.target.value);
  };
  useEffect(() => {
    setPhone(pageData?.contactUsPage?.phoneCode);
  }, [country]);
  return (
    <section className="contact-us">
      <div id="contact-us" className="container contactus-wrap">
        <div className="contactus-left-container">
          <h2 style={{ color: 'black' }}>{pageData?.contactUsPage?.header}</h2>
          <p style={{ fontFamily: 'matter', color: 'black', width: '80%' }}>
            {pageData?.contactUsPage?.subtitle}
          </p>

          <span
            className="contact-us-info"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <EmailOutlinedIcon fontSize="medium" style={{ color: 'blue' }} />
            <p style={{ paddingTop: '0px' }}>
              {pageData?.contactUsPage?.email}
            </p>
          </span>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginTop: '10px',
            }}
          >
            <WhatsAppIcon fontSize="medium" style={{ color: 'green' }} />
            <p style={{ paddingTop: '0px' }}>
              {pageData?.contactUsPage?.mobile1}
            </p>
          </span>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginTop: '10px',
            }}
          >
            <CallIcon fontSize="medium" />
            <p style={{ paddingTop: '0px' }}>
              {pageData?.contactUsPage?.mobile2}
            </p>
          </span>

          <div className="contact-us-description">
            <div
              className="contact-us-description-left"
              style={{ margin: '5px' }}
            >
              <h6 style={{ fontFamily: 'matterMedium' }}>
                {pageData?.contactUsPage?.dec1header}
              </h6>
              <p
                style={{
                  paddingTop: '5px',
                  color: 'black',
                }}
              >
                {pageData?.contactUsPage?.dec1Content}
              </p>
            </div>
            <div
              className="contact-us-description-right"
              style={{ margin: '5px' }}
            >
              <h6 style={{ fontFamily: 'matterMedium' }}>
                {pageData?.contactUsPage?.dec2Header}
              </h6>
              <p
                style={{
                  paddingTop: '5px',
                  color: 'black',
                }}
              >
                {pageData?.contactUsPage?.dec2Content}
              </p>
            </div>
          </div>
        </div>
        <div className="contactus-right-container">
          <div className="contactus-card">
            <h4
              style={{
                marginBottom: '0px',
                color: 'black',
                fontFamily: 'matterThin',
              }}
            >
              {pageData?.contactUsPage?.formHeader}
            </h4>
            <p
              style={{
                paddingTop: '0px',
                marginBottom: '5px',
                color: 'black',
                marginBottom: '10px',
                fontFamily: 'matterThin',
              }}
            >
              {pageData?.contactUsPage?.fromSubtitle}
            </p>
            <TextField
              variant="standard"
              placeholder={pageData?.contactUsPage?.fromLableName}
              sx={{
                width: '100%',
                marginBottom: 2,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    // borderRadius: 3,
                    borderColor: '#0c286a',
                  },
                  '&:hover fieldset': {
                    borderColor: '#0c286a',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#0c286a',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#0c286a',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0c286a',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#0c286a',
                  // opacity: 1, // To ensure the color is applied properly
                  fontSize: '14px',
                },
              }}
            />
            <TextField
              placeholder={pageData?.contactUsPage?.fromLableEmail}
              variant="standard"
              sx={{
                width: '100%',
                marginBottom: 2,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderRadius: 3,
                    borderColor: '#0c286a',
                  },
                  '&:hover fieldset': {
                    borderColor: '#0c286a',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#0c286a',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#0c286a',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0c286a',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#0c286a',
                  fontSize: '14px',
                  // opacity: 1, // To ensure the color is applied properly
                },
              }}
            />
            <Paper
              component="form"
              sx={{
                p: '4px 8px',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: 600, // adjust max-width for mobile
                borderRadius: 3, // Rounded corners for a softer look
                boxShadow: 0, // Slight shadow for better visibility
                // border: 1,
                // borderColor: '#0c286a',
                // backgroundColor: '#eff3ff',
              }}
            >
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={phone}
                onChange={handleChange}
                sx={{
                  // Styles for the Select component
                  '& .MuiSelect-select': {
                    padding: '10px 14px',
                    fontSize: '16px',
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0c286a', // Border color on hover
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#0c286a', // Border color when focused
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#0c286a',
                    fontSize: '14px',

                    // opacity: 1, // To ensure the color is applied properly
                  },
                }}
              >
                <MenuItem value={+91}>+91</MenuItem>
                <MenuItem value={+60}>+60</MenuItem>
                <MenuItem value={+66}>+66</MenuItem>
                <MenuItem value={+62}>+62</MenuItem>
              </Select>
              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              <InputBase
                sx={{
                  flex: 1,
                  ml: 1,
                  '& .MuiInputBase-input::placeholder': {
                    color: '#0c286a',
                    fontSize: '14px',
                    // opacity: 1, // To ensure the color is applied properly
                  },
                }}
                placeholder={pageData?.contactUsPage?.fromLablePhone}
                inputProps={{ 'aria-label': 'search' }}
              />
            </Paper>
            <TextField
              id="outlined-multiline-static"
              multiline
              rows={4}
              placeholder={pageData?.contactUsPage?.fromLableHelpText}
              variant="standard"
              sx={{
                width: '100%',
                marginBottom: 2,
                marginTop: 2,
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderRadius: 3,
                    borderColor: '#0c286a',
                  },
                  '&:hover fieldset': {
                    borderColor: '#0c286a',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#0c286a',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: '#0c286a',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: '#0c286a',
                },
                '& .MuiInputBase-input::placeholder': {
                  color: '#0c286a',
                  fontSize: '14px',
                  // opacity: 1, // To ensure the color is applied properly
                },
              }}
            />
            <Button
              sx={{
                width: '100%',
                height: '50px',
                fontSize: '18px',
                backgroundColor: '#003cc4',
                borderRadius: 3,
              }}
              variant="contained"
            >
              {pageData?.contactUsPage?.formBtnText}
            </Button>
            <p
              style={{
                fontFamily: 'matter',
                textAlign: 'center',
                color: 'black',
                fontSize: '16px',
              }}
            >
              {pageData?.contactUsPage?.formTerms}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
